import { useContext, useState, useEffect, createContext } from 'react';

import { selectors as settingsSelectors } from 'state/settings';
import { useSelector } from 'react-redux';

const FeatureFlagContext = createContext({});
FeatureFlagContext.displayName = 'FeatureFlagContext';

export const FeatureFlagProvider = ({ children }) => {
  const [featureFlags, setFeatureFlags] = useState({});
  const fetchedFeatureFlags = useSelector(settingsSelectors.getFeatureFlags);

  useEffect(() => {
    const processedFeatureFlags = (fetchedFeatureFlags || []).reduce(
      (obj, featureFlag) => {
        return { ...obj, [`${featureFlag.name}`]: featureFlag.is_active };
      },
      {}
    );

    setFeatureFlags(processedFeatureFlags);
  }, [fetchedFeatureFlags, setFeatureFlags]);

  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

const useFeatureFlag = () => {
  const featureFlags = useContext(FeatureFlagContext);

  return featureFlags;
};

export default useFeatureFlag;
